import { createFileRoute } from '@tanstack/react-router';

import { OauthConsentPage } from '../../modules/oauth-consent/oauth-consent-page.js';

export const Route = createFileRoute('/oauth/consent')({
  validateSearch: (search: Record<string, unknown>) => ({ uid: String(search.uid ?? '') }),
  component: ConsentRoute,
});

// eslint-disable-next-line react-refresh/only-export-components
function ConsentRoute() {
  const { uid } = Route.useSearch();
  return <OauthConsentPage uid={uid} />;
}
